import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ReactGA from 'react-ga4';
import SearchPage from './SearchPage';
import './App.css';

const TRACKING_ID = "G-5WCXTPPV37"; // your Measurement ID
ReactGA.initialize(TRACKING_ID);

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<SearchPage />} />
            </Routes>
        </Router>
    );
};

export default App;
